import { render, staticRenderFns } from "./DashboardLockedWidget.vue?vue&type=template&id=ef608394&scoped=true"
import script from "./DashboardLockedWidget.vue?vue&type=script&lang=js"
export * from "./DashboardLockedWidget.vue?vue&type=script&lang=js"
import style0 from "./DashboardLockedWidget.vue?vue&type=style&index=0&id=ef608394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef608394",
  null
  
)

export default component.exports